import type React from 'react';

import { EMOTION_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { EmotionNeutralIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface EmotionAttributeCardProps extends WithDataTestid, WithClassNameProp {
  emotion: 1 | 2 | 3 | 4 | 5 | 6 | 7 | null;
}

export function EmotionAttributeCard({
  emotion,
  className = undefined,
  'data-testid': dataTestId = 'EmotionAttributeCard',
  ...props
}: EmotionAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();
  const description = EMOTION_OPTIONS[emotion]?.label;

  return (
    <AttributeCard
      className={className}
      data={emotion}
      data-testid={dataTestId}
      description={description}
      icon={<EmotionNeutralIcon />}
      title={t('shared:attribute_cards.emotion.title')}
      {...props}
    />
  );
}
